import { YAxis as RechartsYAxis } from 'recharts';

export const YAxis = (
    props: React.ComponentProps<typeof RechartsYAxis>
) => {
    return <RechartsYAxis data-testid={'YAxis-container'} {...props} />;
};

export default YAxis;
